<template>
  <div>
    <div style="width: 100%;padding-top: 16px; margin-top: 0px;">
      <div style="display:flex;justify-content:space-between;align-items:flex-end;margin-bottom: 10px;gap: 5px;">
        <div>
          <b-form-group
            style="width: 100%;"
            :label="$t('Location')"
          >
            <vue-select
              v-model="toLocation"
              :options="getLocationsMoving"
              label="locationName"
              :reduce="(e) => e.locationId"
              :placeholder="$t('Select')"
              style="width: 350px;"
              :clearable="false"
            />
          </b-form-group>
        </div>
        <button
          v-b-modal.change-location-internal
          class="button"
        >
          {{ $t('ChangeLocation') }}
        </button>
      </div>
      <table
        class="team_table"
      >
        <thead>
          <tr>
            <th style="display: flex;gap: 5px">
              <input
                type="checkbox"
                :checked="selectAll"
                @change="toggleSelectAll"
              >
              {{ $t('Select') }}
            </th>
            <th>
              {{ $t('ArticleNumber') }}
            </th>
            <th>
              {{ $t('Location') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in getProductsInStockMovements.data"
            :key="index"
          >
            <td>
              <input
                type="checkbox"
                :value="item.productInStockId"
                :checked="isItemChecked(item)"
                @change="event => toggleOrderItem(event, index)"
              >
            </td>
            <td>
              {{ item.articleNumber }}
            </td>
            <td>
              {{ item.senderLocationName }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="getProductsInStockMovements.items ? getProductsInStockMovements.items.length > 15 : null">
        <b-pagination
          v-model="page"
          :total-rows="getProductsInStockMovements.items"
          :per-page="pageSize"
          first-number
          last-number
          align="fill"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
        >
          <template #prev-text>
            <span class="previousOrNext"><b-icon-arrow-left />{{ $t('Previous') }}</span>
          </template>
          <template #next-text>
            <span class="previousOrNext">{{ $t('Next') }}<b-icon-arrow-right /></span>
          </template>
        </b-pagination>
      </div>
    </div>
    <ChangeLocationInternal
      :order-item-ids="orderItemIds"
      @onSubmit="changeLocations"
    />
    <div
      v-if="isSidebarOpen"
      class="backdrop"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ChangeLocationInternal from './modals/ChangeLocationInternal.vue'


export default {
  components: {
    ChangeLocationInternal,
  },
  data() {
    return {
      isSidebarOpen: false,
      page: 1,
      pageSize: 15,
      orderItemIds: [],
      selectAll: false,
      toLocation: null,
    }
  },
  computed: {
    ...mapGetters(['getCurrentPageFilter', 'getLocationsMoving', 'getTotalItemsFilter', 'getProductsInStockMovements']),

  },
  watch: {
    page(value) {
      if (value) {
        this.filterProductsStockMovements({
          state: 'Pending',
          senderLocationId: this.toLocation,
          pageNumber: value,
          pageSize: this.pageSize,
        })
      }
    },
    toLocation(value) {
      this.filterProductsStockMovements({
        state: 'Pending',
        senderLocationId: value,
        pageNumber: 1,
        pageSize: 15,
      })
      this.selectAll = false
      this.orderItemIds = []
      this.$emit('checkLocation', value)
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions(['filterItemMovement', 'filterProductsStockMovements', 'createProductInStockMovement', 'orderedMaterials', 'shipOrderToManufactory']),
    toggleOrderItem(event, index) {
      const item = this.getProductsInStockMovements.data[index];
      const itemObject = {
        id: item.id,
        productInStockId: item.productInStockId,
        articleNumber: item.articleNumber,
        senderLocationName: item.senderLocationName,
        senderLocationId: item.senderLocationId,
      };

      if (event.target.checked) {
        this.orderItemIds.push(itemObject);
      } else {
        const itemIndex = this.orderItemIds.findIndex(
          (i) => { return i.productInStockId === item.productInStockId && i.articleNumber === item.articleNumber && i.senderLocationName === item.senderLocationName && i.senderLocationId === item.senderLocationId && i.id === item.id },
        );
        if (itemIndex !== -1) {
          this.orderItemIds.splice(itemIndex, 1);
        }
      }
      this.selectAll = this.orderItemIds.length === this.getProductsInStockMovements.data.length;
    },
    toggleSelectAll(event) {
      this.selectAll = event.target.checked;

      if (this.selectAll) {
        this.orderItemIds = this.getProductsInStockMovements.data.map((item) => {
          return {
            id: item.id,
            productInStockId: item.productInStockId,
            articleNumber: item.articleNumber,
            senderLocationName: item.senderLocationName,
            senderLocationId: item.senderLocationId,
          }
        });
      } else {
        this.orderItemIds = [];
      }
    },
    isItemChecked(item) {
      return this.orderItemIds.some(
        (i) => { return i.id === item.id },
      );
    },
    changeLocations(value) {
      this.createProductInStockMovement({
        object: value,
        successCallback: () => {
          this.filterProductsStockMovements({
            state: 'Pending',
            senderLocationId: this.toLocation,
            pageNumber: 1,
            pageSize: 15,
          })
          this.orderItemIds = []
          this.selectAll = false
        },
      })
    },
    showMaterials() {
      this.isSidebarOpen = true
      const materials = this.orderItemIds.map((item) => { return item.orderItemId })
      this.orderedMaterials({
        object: materials,
      })
    },
    onCancelToggle() {
      this.isSidebarOpen = false
    },
  },
}
</script>

<style scoped>
.team_table td {
  padding: 16px 9px !important;
}
.hover-row:hover {
  background-color: rgba(255, 39, 79, 0.1);
}
.cart-counter {
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 0px 7px;
    font-size: 13px;
    position: absolute;
    left: 31.5%;
    top: 6.5%;
}
</style>
